/**
 * checkboxの値の一覧からidの一覧を取得
 * @param checkBoxValues
 * @returns {number[]}
 */
export const getCheckIdList = (checkBoxValues) => Object.keys(checkBoxValues || {})
    .map((id) => ({ check: checkBoxValues[id], id }))
    .filter((v) => v.check)
    .map((v) => parseInt(v.id, 10));
export default getCheckIdList;
